/**
 * JOIN — what an invitation link opens onto (desktop). 3026, docs/INVITES.md.
 *
 * Twin of `app/src/screens/Join.tsx`; the body is shared in
 * `components/JoinCard.tsx` so the two trees cannot drift on the copy, which is
 * the part that carries the meaning here. Only the frame differs: a centred
 * card rather than a full-bleed column.
 *
 * Bare chrome for the same reason — the reader may have no account at all.
 */

import { JoinCard } from '../../components/JoinCard.tsx';
import { QuarterIcon } from '../../components/QuarterIcon.tsx';

const M = {
  headFs: '15px',
  bodyFs: '11px',
  fieldFs: '12px',
  btnFs: 10,
  pad: '0',
};

export default function Join(): JSX.Element {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          width: 460,
          maxWidth: '100%',
          border: '1px solid var(--gt-border)',
          background: 'var(--gt-card)',
          boxShadow: 'var(--gt-shadow-toast)',
          padding: '30px 28px 28px',
          boxSizing: 'border-box',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <QuarterIcon u={3} />
          <div
            style={{
              fontFamily: 'var(--gt-font-pixel)',
              fontSize: '20px',
              color: 'var(--gt-text)',
              lineHeight: 1.6,
              marginTop: '16px',
            }}
          >
            GAMES TONIGHT<span style={{ color: 'var(--acc2)' }}>?</span>
          </div>
        </div>

        <div style={{ marginTop: '24px' }}>
          <JoinCard m={M} />
        </div>
      </div>
    </div>
  );
}
